import { IntlShape } from 'react-intl';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { IOrganizationsListDTO } from '../../../../../api/organizations.dao';
import { IAttendeeDetailsDTO } from '../../../../../api/attendees.dao';
import { AttendeeFormPresentation } from './attendee-form-presentation';
import { AttendeeFormViewModel } from './attendee-form.viewmodel';
import { OpenFrom } from '../../../../../tracking-service/tracking-values';

interface IMeetingFormContainerProps {
    deleteAttendeeOnList?: () => void;
    setDeleteAttendeeAlertKey: (key) => void;
    accountId: number;
    eventId: number;
    attendeeId?: number;
    intl: Readonly<IntlShape>;
    organizationId?: number;
    createOrganizationFromForm?: (callback?: (shouldUpdateOrganizatiosList: boolean) => Promise<IOrganizationsListDTO>) => void;
    saveCompletedCallback: (attendee: IAttendeeDetailsDTO) => void;
    openFrom: OpenFrom;
}

const AttendeeFormContainer = withViewModel(AttendeeFormPresentation, (props: IMeetingFormContainerProps) => {
    const attendeeFormVM = new AttendeeFormViewModel(
        props.intl,
        props.deleteAttendeeOnList,
        props.setDeleteAttendeeAlertKey,
        props.createOrganizationFromForm,
        props.accountId,
        props.eventId,
        props.openFrom,
        props.attendeeId,
        props.saveCompletedCallback,
        props.organizationId,
    );
    attendeeFormVM.initialize(!!props.attendeeId);
    return attendeeFormVM;
}, props => [props.attendeeId]);

export { AttendeeFormContainer as AttendeeForm };
